/* ==========================================================================
   search.js — header search overlay. Matches against window.APYKIDZ_PRODUCTS
   (already embedded globally for cart.js) by product title.
   In Shopify, swap the in-memory match for a fetch to the Predictive
   Search API — the overlay markup and data-search-* hooks don't change.
   ========================================================================== */
(function () {
  "use strict";

  var overlay = document.querySelector("[data-search-overlay]");
  if (!overlay) return;

  var input = overlay.querySelector("[data-search-input]");
  var resultsEl = overlay.querySelector("[data-search-results]");
  var hintEl = overlay.querySelector("[data-search-hint]");
  var emptyEl = overlay.querySelector("[data-search-empty]");
  var PRODUCTS = window.APYKIDZ_PRODUCTS || [];

  function money(n) {
    return "$" + Number(n).toFixed(2);
  }

  function resultTemplate(p) {
    var mediaInner = p.image
      ? '<img src="' + p.image + '" alt="' + p.title + '" class="media-image">'
      : '<span style="font-size:1.4rem">' + p.emoji + "</span>";
    return (
      '<a class="search-result-item" href="' + p.slug_url + '" data-search-close>' +
        '<span class="search-result-media ' + p.gradient + '">' + mediaInner + "</span>" +
        '<span>' +
          '<span class="search-result-title">' + p.title + "</span><br>" +
          '<span class="search-result-price">' + money(p.price) + "</span>" +
          ' <span class="card-likes search-result-likes" data-wish-likes="' + p.id + '">' +
            '<svg class="icon icon-sm" aria-hidden="true"><use href="#icon-heart"></use></svg>' +
            '<span><span data-wish-likes-count></span> likes</span>' +
          "</span>" +
        "</span>" +
      "</a>"
    );
  }

  function runSearch() {
    var term = (input.value || "").trim().toLowerCase();
    if (!term) {
      hintEl.style.display = "";
      resultsEl.style.display = "none";
      resultsEl.innerHTML = "";
      emptyEl.style.display = "none";
      return;
    }
    hintEl.style.display = "none";
    var matches = PRODUCTS.filter(function (p) {
      return p.title.toLowerCase().indexOf(term) !== -1;
    }).slice(0, 8);

    if (matches.length === 0) {
      resultsEl.style.display = "none";
      resultsEl.innerHTML = "";
      emptyEl.style.display = "";
      return;
    }
    emptyEl.style.display = "none";
    resultsEl.style.display = "flex";
    resultsEl.innerHTML = matches.map(function (p) {
      return resultTemplate({
        id: p.id,
        title: p.title,
        price: p.price,
        emoji: p.emoji,
        image: p.image,
        gradient: p.gradient,
        slug_url: "/products/" + p.slug + "/",
      });
    }).join("");
    if (window.ApykidzWishlist) window.ApykidzWishlist.refresh(); // fills in the "N likes" numbers
  }

  function openSearch() {
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearch() {
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  document.querySelectorAll("[data-search-toggle]").forEach(function (btn) {
    btn.addEventListener("click", openSearch);
  });
  /* Delegated (not a direct listener) so it still works for result links
     that get added to the DOM after the initial page load. */
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-close]")) closeSearch();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) closeSearch();
  });
  input.addEventListener("input", runSearch);

  window.ApykidzSearch = { open: openSearch, close: closeSearch };
})();
